import { NgModule } from '@angular/core';
import { TreatmentPlanDialogComponent } from './treatment-plan-dialog.component';
import { CommonModule } from '@angular/common';
import { IconModule } from '@shared-components';

@NgModule({
  declarations: [TreatmentPlanDialogComponent],
  exports: [TreatmentPlanDialogComponent],
  imports: [
    CommonModule,
    IconModule
  ]
})
export class TreatmentPlanDialogComponentModule {}
